import { CustomerInfo } from "./liquid/snippets/si-customer-info";

declare global {
  interface Window {
    siCustomerInfo: CustomerInfo;
    si: {
      apiUrl: string;
      storeHash: string;
    };

    Shopify: {
      currency: {
        active: string;
      };
      country: string;
    };
  }
}

export {};
